import React from 'react'
import LookQuestionType from './lookQuestionType'
import { WizTableForm } from '@/containers/common';
import { framework_tool,component_tool,utils_tool } from "@/tool";
const { WizAvatarUpload,ossFileUtils } = framework_tool;
let { $$,checkStrLength } = utils_tool;
import {PhotoProvider, PhotoView} from 'react-photo-view';
import 'react-photo-view/dist/react-photo-view.css';
const { WizModal,WizPopover } = component_tool;

// const questionTypeConfig = data => WizTableForm.Config.questionType(this, { apiParams: { type: data } })

//配置项
let componentName = 'questionType'
let ref;

const columns = (data, parent) => {
    let columnsRef = []
    columnsRef = columnsRef.concat([
      {
        name: "id",
        formItem: {
          type: "hidden"
        }
      },
      {
        name: "type",
        searchItem: {
          type: "hidden",
        },
        formItem: {
          type: "hidden",
        }
      },
      {
        name: "createBy",
        formItem: {
          type: "hidden",
        }
      },
      {
        name: "createTime",
        formItem: {
          type: "hidden",
        }
      },
      {
        name: "sort",
        formItem: {
          type: "hidden"
        }
      },
    ])
    if (parent !== 'no') {
      columnsRef = columnsRef.concat([
        {
          title: "上级分类",
          name: "parentId",
          dataIndex: "parentId",
          dict: {
            wizReplaceData: "treeData",
            defalutType: []
          },
          formItem: {
            type: 'treeselect',
            allowClear: true,
            // ...questionTypeConfig(data),
            // diy: WizTableForm,
            // selectType: 'radio',
          },
        }
      ])
    }
    columnsRef = columnsRef.concat([
      {
        title: "分类名称",
        name: "name",
        dataIndex: "name",
        formItem: {
          maxLength: 40,
          placeholder: '分类名称最多输入40个字',
          rules: [
            {
              required: true,
              message: '请输入分类类型名称'
            },
            {
              pattern: /^[^\s]*$/,
              message: '分类类型名称录入信息不能包含空格'
            }
          ],
        },
        searchItem: {},
        tableItem: {width: 120,}
      },
    ])
  if (data === '18'){
    columnsRef = columnsRef.concat([
      {
        title: "封面",
        name: "img",
        dataIndex: "img",
        tableItem: {
          width: 50,
          render: (text, record) => <div>
            {
              record.img ?
                (<PhotoProvider
                  toolbarRender={({onScale, scale}) => {
                    return (
                      <>
                        <svg className="PhotoView-Slider__toolbarIcon" onClick={() => onScale(scale + 1)}/>
                        <svg className="PhotoView-Slider__toolbarIcon" onClick={() => onScale(scale - 1)}/>
                      </>
                    );
                  }}>
                  <div className="foo">
                    <PhotoView key={'img_' + record.img} src={getOssFilePath(record.img)}>
                      <a>查看</a>
                    </PhotoView>
                  </div>
                </PhotoProvider>): null
            }
          </div>
        },
      },
    ])
  }
    if (parent !== 'no') {
      columnsRef = columnsRef.concat([
        {
          title: "上级分类",
          name: "parentName",
          dataIndex: "parentName",
          tableItem: { width: 240,}
        },])
    }
  if (data === '18'){
    columnsRef = columnsRef.concat([
      {
        title: "状态",
        name: "state",
        dataIndex: "state",
        dict: [
          {code: 1, codeName: data === '18' ? "启用" : "有效"},
          {code: 0, codeName: data === '18' ? "禁用" : "无效"}
        ],
        formItem: {
          type: "radio",
          initialValue: 1,
          rules: [{
            required: true,
            message: '请选择状态',
          }],
        }
      },
      {
        title: "简介",
        name: "intro",
        dataIndex: "intro",
        ellipsis:true,
        tableItem: {
          width: 150,
          render: (text,record) =>{
            let contextList = text && text.split(',').length ? text.split(',') : []
            let value_ = text;
            let content = [];
            let _titleView = []
            if (text && text.length && text.length>20) {
              value_ = text.substring(0, 20)
              content.push(<p style={{width:300}} >{text}</p>);
            }else {
              content.push(<p>{text}</p>);
            }
            _titleView.push(value_)
            if(text && text.length && text.length>20){
              _titleView.push(<span className='wiz-press-font-color'> ...</span>)
            }
            return (
              <WizPopover content={content} placement="topRight">
                {_titleView}
              </WizPopover>
            )
          }
        },
        formItem: {
          type: 'textarea',
          placeholder: '请输入简介,最多100字',
          maxLength: 100,
        }
      },
    ])
  }else {
    columnsRef = columnsRef.concat([
      {
        title: "状态",
        name: "state",
        dataIndex: "state",
        dict: [
          {code: 1, codeName: data === '18' ? "启用" : "有效"},
          {code: 0, codeName: data === '18' ? "禁用" : "无效"}
        ],
        formItem: {
          type: "select",
          initialValue: 1,
          rules: [{
            required: true,
            message: '请选择状态',
          }],
        }
      },
      {
        title: "简介",
        name: "intro",
        dataIndex: "intro",
        ellipsis:true,
        tableItem: {
        },
        formItem: {
          type: 'textarea',
          placeholder: '请输入简介,最多100字',
          maxLength: 100,
        }
      },
    ])
  }
    columnsRef = columnsRef.concat([
      {
        title: "状态",
        name: "state",
        dataIndex: "state",
        tableItem: {
        },
        dict: [
          {code: 1, codeName: data === '18' ? "启用" : "有效"},
          {code: 0, codeName: data === '18' ? "禁用" : "无效"}
        ],
        searchItem: {
          type: "select"
          // mode: 'multiple',
        },
      },
   ])
  if (data === '18'){
    columnsRef = columnsRef.concat([
      {
        title: '封面',
        formItem: {
          type: 'custom',
          render: (record, form) => {
            const { getFieldDecorator } = form
            return (
              <>
                {getFieldDecorator('img', {
                  rules: [
                    {
                      required: true,
                      message: '请上传封面'
                    }
                  ],
                  initialValue: (record && record.img) ? [
                    { fileId: record.img }
                  ] : [],
                })(
                  <WizAvatarUpload
                    accept={'.jpg, .jpeg, .png, .bmp '}
                    listType={'picture-card'}
                    aspectRatio={400 / 207}
                    beforeUpload={(file) => {
                      const isLt10M = file.size / 1024 / 1024 < 10;
                      if (!isLt10M) {
                        Wizmessage.error('图片不得超过10M!');
                      }
                      return isLt10M;
                    }}
                  />
                )}
              </>
            )
          }
        },
      },
    ])
  }
    return columnsRef
  }
;

const templateConfig = (data) => {
  const {type, parent, pathname} = data;
  let searchBarButtonsSort=[];
  if (type=== '18'){
    searchBarButtonsSort = searchBarButtonsSort.concat([
      'exportCategory', 'delete'
    ]);
  }else {
    searchBarButtonsSort = searchBarButtonsSort.concat([
      'add', 'delete', 'batchImport', 'export'
    ]);
  }
  let rowOperateSort=[];
  if (type=== '18'){
    rowOperateSort = rowOperateSort.concat(['enableOrDisable', 'update','authorityManagement']);
  }else {
    rowOperateSort = rowOperateSort.concat(['look', 'update','authorityManagement' ]);
  }
  let rowOperateView= [];
  if (type==='18'){
    rowOperateView = rowOperateView.concat([
      {
        key: "enableOrDisable",
        custom: true,
        params: {},//状态  0无效  1有效
        textFormat: {
          recordKey: 'state',
          dirt: {  1: '禁用', 0: '启用' }
        },
        customOnClick: {
          key: "action",
          params: {
            apiKey: "enable",
            apiParams: {}
          },
          formatParams: (rows, record, filters, callback) => {
            const content = `您确定要${
              record['state'] === 0 ? (type === '18' ? "启用" : "有效") : (type === '18' ? "禁用" : "无效")
            }该分类？`;
            WizModal.confirm({
              title: '注意', content,
              onOk: () => {
                callback && callback({
                  state: record['state'] === 1 ? 0 : 1,
                  ids: [record['id']]
                })
              },
              onCancel() {
              }
            });
            return null
          }
        }
      }
    ]);
  }else if (type==='2'){
    rowOperateView = rowOperateView.concat([
      {
        key: "look",
        custom: true,
        params: {children: "查看"},
        customOnClick: {
          key: "modal",
          params: {
            modalKey: "questionTypeLook",
            modalParams: {
              title: "查看题目分类",
              cancelButtonProps: {style: {height: 0, width: 0}},
              style: {minWidth: 700},
              footer: null,
              diy: (e) => {
                return (
                  <LookQuestionType
                    key={'questionTypeLook' + e.record.id}
                    {...e}
                    ref={r => {
                      ref = r && r.getWrappedInstance();
                    }}
                  />
                )
              },
              onOk: () => {
                ref._ok();
              },
              width: 600
            },
          }
        }
      }
    ]);
  }
  rowOperateView = rowOperateView.concat([
    {
      key: "authorityManagement",
      custom: true,
      params: {children: "权限管理"},
      customOnClick: {
        key: "jumpPage",
        params: {
          key: 'push',
          pathname: `${pathname}/auth`,
          record: {type: type}
        }
      }
    }
  ]);
  const columnsInfo = columns(type, parent);
  let returnObj = {
      name: "WizTableListNew",
      params: {
        columns: columnsInfo,
        searchBarProps: {
          buttonSort: searchBarButtonsSort,
          buttons: [
            {
              key: 'exportCategory',
              custom: true,
              params: {icon: "export", children: "导出", type: "export"},
              customOnClick: {
                key: 'action',
                params: {
                  apiKey: "exportCategory",
                  apiParams: {}
                },
                formatParams: (rows, record, filters, callback) => {
                  return {...filters}
                }
              }
            },
            {
              key: 'export',
              custom: true,
              params: {icon: "export", children: "导出", type: "export"},
              customOnClick: {
                key: 'action',
                params: {
                  apiKey: "export",
                  apiParams: {}
                },
                formatParams: (rows, record, filters, callback) => {
                  return {...filters}
                }
              }
            },
            {
              key: "delete",
              custom: true,
              needSelect: true,
              params: {icon: "delete", children: "删除", type: "danger"},
              customOnClick: {
                key: "action",
                params: {
                  apiKey: "delete",
                  apiParams: {}
                },
                formatParams: (rows, record, filters, callback) => {
                  if (!rows) return;
                  if ($$.isArray(rows) && !rows.length) return;
                  const content = '您是否确认删除当前选中的分类？'
                  let ids = [];
                  rows.forEach(e => {
                    if (e['rowKey']){
                      ids.push(e['rowKey']);
                    }
                  });
                  WizModal.confirm({
                    title: '注意', content,
                    onOk: () => {
                      callback && callback({
                        ids
                      })
                    },
                    onCancel() {
                    }
                  });
                  return null
                }
              }
            },
            {
              key: 'batchImport',
              custom: true,
              params: {icon: 'import', children: '批量导入', type: 'import'},
              customOnClick: {
                key: 'jumpPage',
                params: {
                  key: 'push',
                  pathname: `${pathname}/fileImport`,
                  record: {type: type}
                }
              },
            }
          ],
          collapse: false,
        },
        modalFormProps: {
          dataFormat:(v)=>{
            let _v = v;
            if (v && v['img'] && v['img'].length) {
              _v.img = v.img[0].fileId;//img获取对应上传实体的fileId
            }else{
              _v.img = "";
            }
            return _v
          }
        },
        dataTableProps: {
          rowKey: "id",
          selectType: "checkbox",
          isScroll: true,
          loading: false
        },
        rowOperateSort: rowOperateSort,
        commonOperate: {
          add: true,
          update: true,
          delete: true,
          look: false
        },
        rowOperateView: rowOperateView
      }
  }
  if (parent !== 'no') {
    let buttonSort = [];
    let buttons = [];
    let defaultExpandedKeys = [];
    if (type === '18'){
      buttonSort = buttonSort.concat(['sideBarAdd','sideBarAddChildren', 'sideBarUpdate','moveUp','moveDown']);
      buttons = buttons.concat([]);
      defaultExpandedKeys = ['0-0'];
    }
    returnObj.params.siderBarProps ={
      key: "nodeTree_category",
      searchKey: "id",
      treeEntityKey:"entity",
      treeEntityRowKey: "id",
      otherProps: {
        defaultExpandedKeys:defaultExpandedKeys,
      },
      modalFormSideBarProps:{
        dataFormat:(v)=>{
          let _v = v;
          if (v && v['img'] && v['img'].length) {
            _v.img = v.img[0].fileId;//img获取对应上传实体的fileId
          }else{
            _v.img = "";
          }
          return _v
        }
      },
      params: {type},
      buttonSort: buttonSort,
      buttons: buttons,
    }
  }
  return {
    mainProps: {},
    content:returnObj
  }
};


let reduxTemplateCofig = (args) => {
  const {type, parent} = args;
  const apis = {
    list: {
      path: `${componentName}/${type === '2' || type === '18' ? 'normalListByPage' : 'listByPage'}`,
      payload: {
        key: `${componentName}@listByPage`,
        apiParams: {pageNum: 1, pageSize: 10, type}
      }
    },
    export: {
      path: `${componentName}/export`,
      payload: {
        key: `${componentName}@export`,
        apiParams: {type,sceneType:type === '2' || type === '18' ? 126 : null}
      }
    },
    exportCategory: {
      path: `${componentName}/export`,
      payload: {
        key: `${componentName}@exportCategory`,
        apiParams: {type,sceneType:type === '2' || type === '18' ? 126 : null}
      }
    },
    treeData: {
      path: `${componentName}/${type === '2' || type === '18' ? 'normalNodeList' : 'nodeList'}`,
      payload: {
        key: `${componentName}@treeData`,
        apiParams: {type,needEntity: type === '18' ? 1: 0}
      }
    },
    add: {
      path: `${componentName}/add`,
      payload: {
        key: `${componentName}@add`,
        apiParams: {type}
      }
    },
    sideBarAdd: {
      path: `${componentName}/add`,
      payload: {
        key: `${componentName}@sideBarAdd`,
        apiParams: {type}
      }
    },
    sideBarAddChildren: {
      path: `${componentName}/add`,
      payload: {
        key: `${componentName}@sideBarAddChildren`,
        apiParams: {type}
      }
    },
    update: {
      path: `${componentName}/upd`,
      payload: {
        key: `${componentName}@upd`,
        apiParams: {type}
      }
    },
    sideBarUpdate: {
      path: `${componentName}/upd`,
      payload: {
        key: `${componentName}@sideBarUpdate`,
        apiParams: {type}
      }
    },
    delete: {
      path: `${componentName}/del`,
      payload: {
        key: `${componentName}@del`,
        apiParams: {type}
      }
    },
    enable: {
      path: `${componentName}/enable`,
      payload: {
        key: `${componentName}@enable`,
        apiParams: {}
      }
    },
    moveUp: {
      path: `${componentName}/sort`,
      payload: {
        key: `${componentName}@moveUp`,
        apiParams: {sortType:1}
      }
    },
    moveDown: {
      path: `${componentName}/sort`,
      payload: {
        key: `${componentName}@moveDown`,
        apiParams: {sortType:-1}
      }
    }
  };
  return {
    apis,
    componentName,
    initApiKeys: ['list', 'treeData'],
    keepInitApiParams: true,
    needLoading: true,
    ...args
  }
};

export {reduxTemplateCofig, templateConfig};
